import { ActiveMinutes } from '@dialogue/services'

export enum DISTANCE_UNITS {
  KM = 'km',
  MILE = 'mile',
}

export const REGION_UNIT: Record<string, Record<string, DISTANCE_UNITS>> = {
  US: {
    [ActiveMinutes.Types.ActivityMetric.DistanceMeters]: DISTANCE_UNITS.MILE,
  },
  default: {
    [ActiveMinutes.Types.ActivityMetric.DistanceMeters]: DISTANCE_UNITS.KM,
  },
}
